<template>
  <div class="d-flex align-items-end">
    <!--     <editor
      v-if="!in_edition || disabled"
      key="editor-disabled"
      v-model="local_value"
      lang="python"
      theme="idle_fingers"
      width="100%"
      style="fontsize: 18px;"
      @init="initialize_editor($event, true)"
    />
    <editor
      v-else
      key="editor-editing"
      v-model="local_value"
      lang="python"
      theme="chrome"
      width="100%"
      style="fontsize: 18px;"
      @init="initialize_editor($event)"
    /> -->

    <editor
      v-if="!in_edition || disabled"
      key="editor-disabled"
      v-model="local_value"
      lang="python"
      theme="idle_fingers"
      width="100%"
      style="font-size: 18px;"
      @init="initialize_editor($event, true)"
    />
    <editor
      v-else
      key="editor-editing"
      v-model="local_value"
      lang="python"
      theme="chrome"
      width="100%"
      style="font-size: 18px;"
      @init="initialize_editor($event)"
    />
    <b-button-group v-if="!disabled">
      <b-button @click="toggle_edition()" variant="outline-secondary">
        <span v-if="in_edition" class="fas fa-check fa-xs fa-fw" />
        <span v-else class="fas fa-pen fa-xs fa-fw" />
      </b-button>
      <b-button
        v-if="in_edition"
        @click="cancel_edition()"
        variant="outline-secondary"
      >
        <span class="fas fa-times fa-xs fa-fw"
      /></b-button>
    </b-button-group>
  </div>
</template>

<script>
import _ from 'lodash'

import editor from 'vue2-ace-editor'
import * as ace from 'brace'
import 'brace/ext/language_tools'
import 'brace/mode/python'
import 'brace/mode/less'
import 'brace/theme/chrome'
import 'brace/snippets/python'
import 'brace/theme/idle_fingers'
import Fuse from 'fuse.js'

// *****************************************************************************

export default {
  name: 'TogglableCodeEditor',
  components: {
    editor,
  },
  props: ['value', 'columns', 'disabled'],
  data() {
    return {
      local_value: '',
      in_edition: false,
      fuzzy_searcher: () => [],
    }
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.local_value = nv
        }
      },
    },
    columns(nv, ov) {
      let searcher = new Fuse(nv, {
        includeScore: true,
      })
      this.fuzzy_searcher = v => searcher.search(v)
    },
  },

  methods: {
    toggle_edition() {
      this.$emit('input', this.local_value)
      this.in_edition = !this.in_edition
    },
    cancel_edition() {
      this.local_value = this.value
      this.in_edition = !this.in_edition
    },

    initialize_editor(editor, read_only = false) {
      editor.setReadOnly(read_only)
      editor.setOption('minLines', 10)
      editor.setOption('maxLines', 25)

      editor.setOptions({
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
      })

      let column_completer = {
        getCompletions: (editor, session, pos, prefix, callback) => {
          let res = []
          if (prefix.length !== 0) {
            let temp = this.fuzzy_searcher(prefix)
            res = temp.map(function(ea) {
              return {
                name: ea.item,
                value: ea.item,
                score: ea.score,
                meta: 'column',
              }
            })
          }
          callback(null, res)
        },
      }
      // https://github.com/thlorenz/brace/wiki/Advanced:-Accessing-somewhat-hidden-ACE-features
      let lang_tools = ace.acequire('ace/ext/language_tools')
      lang_tools.addCompleter(column_completer)
    },
  },
}
</script>
